import type React from 'react';

import * as styles from './styles';
import { FormControl as MuiFormControl } from '@material-ui/core';

import { Orientation } from '../styles';

interface IProps {
  orientation?: Orientation;
  className?: string;
  error?: boolean;
  onFocus?: React.EventHandler<any>;
  onChange?: React.EventHandler<any>;
  onBlur?: React.EventHandler<any>;
  fullWidth?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  id?: string;
}

// https://material-ui.com/api/form-control/
/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const FormControl: React.FC<IProps> = ({ orientation = Orientation.VERTICAL, ...props }: IProps) => {
  return <MuiFormControl classes={{ root: styles.formControl(orientation) }} {...props} />;
};
